import React, { Component } from 'react';

class Footer extends Component {
    render() {
        if (this.props.getFooter.loading) {
            return 'Loading...'
        };
        if (this.props.getFooter.error) {
            return 'Error fetch data';
        }
        let footer = this.props.getFooter.getFooter;
        return (
            <div>
                <div className="footer">
                    <div className="container">
                        <div dangerouslySetInnerHTML={{__html: footer.content}} />
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js